import React, {useContext} from 'react'
import ListBrandsContext from "../../context/ListBrandsContext";
import moment from "moment";

const TableRow = (props) => {
    const {handleClickEditBrand} = useContext(ListBrandsContext)
    const {brand} = props

    const _handleClickEdit = () => {
        handleClickEditBrand(brand._id,brand.name, brand.store)
    }

    return (
        <tr className="TableRow">
            <td className="name">{brand.name}</td>
            <td className="store">{brand.store}</td>
            <td>{moment(brand.created_at).format("HH:mm DD/MM/YYYY")}</td>
            <td>{moment(brand.updated_at).format("HH:mm DD/MM/YYYY")}</td>
            <td className="text-center">
                <span className="text-primary" onClick={_handleClickEdit}>
                    Edit
                </span>
            </td>
        </tr>
    )
}

export default TableRow
